export default "__VITE_ASSET__4c3280fd__"